export default ['listarCadastrosInvalidos'];
